export const getDashboardAttachments = (msg) => (msg.attachments || []);
export const getDashboardType = (msg) => {
    const atts = getDashboardAttachments(msg);
    const hasLab = atts.some((a) => a.type === 'lab_results');
    const tele = atts.find((a) => a.type === 'telehealth_appointment');
    const hasTeleReminder = atts.some((a) => a.type === 'telehealth_appointment_reminder');
    const hasProviderAssignment = atts.some((a) => a.type === 'provider_assignment');
    if (hasLab)
        return 'testsResults';
    if (tele)
        return 'visit';
    if (hasTeleReminder)
        return 'teleReminder';
    if (hasProviderAssignment)
        return 'provider_assignment';
    return null;
};
export const getDashboardStart = (msg) => {
    var _a, _b, _c, _d, _e;
    const type = getDashboardType(msg);
    const atts = getDashboardAttachments(msg);
    if (type === 'visit') {
        const tele = atts.find((a) => a.type === 'telehealth_appointment');
        return (tele === null || tele === void 0 ? void 0 : tele.appointed_start) || ((_a = msg.consultation) === null || _a === void 0 ? void 0 : _a.created) || msg.created;
    }
    if (type === 'testsResults') {
        return (((_b = atts.find((a) => a.type === 'lab_results')) === null || _b === void 0 ? void 0 : _b.created) || msg.created);
    }
    if (type === 'teleReminder') {
        return (((_c = atts.find((a) => a.type === 'telehealth_appointment_reminder')) === null || _c === void 0 ? void 0 : _c.created) || msg.created);
    }
    if (type === 'provider_assignment') {
        return (((_d = atts.find((a) => a.type === 'provider_assignment')) === null || _d === void 0 ? void 0 : _d.created) ||
            msg.created);
    }
    return ((_e = msg.consultation) === null || _e === void 0 ? void 0 : _e.created) || msg.created;
};
export const getDashboardStatus = (msg) => {
    var _a;
    const s = ((_a = msg.consultation) === null || _a === void 0 ? void 0 : _a.status) || '';
    if (s === 'created' || s === 'draft')
        return 'new';
    if (s === 'in_progress' || s === 'on_hold')
        return 'in_progress';
    return 'finished';
};
export const getDashboardIsStat = (msg) => { var _a; return Boolean((_a = msg.consultation) === null || _a === void 0 ? void 0 : _a.stat); };
export const getDashboardProgramName = (msg) => { var _a; return ((_a = msg.consultation) === null || _a === void 0 ? void 0 : _a.service_title) || ''; };
export const getDashboardTests = (msg) => getDashboardAttachments(msg)
    .filter((a) => a.type === 'lab_results')
    .map((a) => a.content_type || 'Lab results');
export const getTelehealthAppointmentId = (attachments) => {
    const telehealthAppointments = attachments.filter((el) => el.type === 'telehealth_appointment');
    if (telehealthAppointments.length === 0) {
        return null;
    }
    if (telehealthAppointments.length === 1) {
        return telehealthAppointments[0].appointment_id;
    }
    const activeAppointment = telehealthAppointments.find((el) => el.status !== 'canceled');
    return activeAppointment ? activeAppointment.appointment_id : null;
};
